module.exports = __webpack_public_path__ + "media/images/iconInfo__okGreen--dark-1efb48c1c051247e2f7ecad501b85890.png";